import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

const initialState = {
  isOpen: true,
}

export const userSidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    updateSidebar(state, action: PayloadAction<boolean>) {
      console.log("action.payload", action.payload)
      state.isOpen = action.payload
    },
    resetMenuItems(state) {
      state.isOpen = false
    },
  },
})

const persistConfig = {
  key: "sidebar",
  storage,
  whitelist: ["isOpen"],
}

export const userSidebarSliceReducer = persistReducer(
  persistConfig,
  userSidebarSlice.reducer,
)

export const { updateSidebar, resetMenuItems } = userSidebarSlice.actions

export default userSidebarSlice.reducer
